// extracted by mini-css-extract-plugin
module.exports = {"tipBox":"style_tipBox__1DiDM","image":"style_image__3Rlt6"};